(function () {
  'use strict';

  var POLL_INTERVAL_MS = 3000;
  var PAGE_NAMES = {
    homepage: 'Homepage',
    collection: 'Collection',
    pdp: 'Product page',
    cart: 'Cart',
    checkout: 'Checkout'
  };
  var REPORT_TAB_CONFIG = [
    { id: 'homepage', label: 'Homepage', pages: ['homepage'], sections: ['above_the_fold'] },
    { id: 'collection', label: 'Collection', pages: ['collection'], sections: [] },
    { id: 'pdp', label: 'Product page', pages: ['pdp'], sections: ['product_page'] },
    { id: 'cart-checkout', label: 'Cart & checkout', pages: ['cart', 'checkout'], sections: ['cart_checkout'] },
    { id: 'storewide', label: 'Storewide', pages: [], sections: ['mobile_experience', 'speed', 'urgency_scarcity'] }
  ];

  function apiBase(root) {
    return (root.dataset.apiBase || window.CRO_API_BASE || '').replace(/\/$/, '');
  }

  async function request(root, path, options) {
    options = options || {};
    var response = await fetch(apiBase(root) + path, Object.assign({}, options, {
      headers: Object.assign({
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      }, options.headers || {})
    }));
    var body = await response.json().catch(function () { return {}; });

    if (!response.ok) {
      throw new Error(body.error || ('Request failed (' + response.status + ')'));
    }

    return body;
  }

  function text(value, fallback) {
    return value == null || value === '' ? (fallback || 'Unavailable') : String(value);
  }

  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }

  function append(parent) {
    for (var i = 1; i < arguments.length; i += 1) {
      var child = arguments[i];
      if (child != null) parent.appendChild(child);
    }
    return parent;
  }

  function clearNode(parent) {
    while (parent.firstChild) parent.removeChild(parent.firstChild);
    return parent;
  }

  function collectFindings(items) {
    var findings = [];
    (items || []).forEach(function (item) {
      (item.findings || []).forEach(function (finding) {
        findings.push(finding);
      });
    });
    return findings;
  }

  function safeHref(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (_error) {
      return '';
    }
  }

  function link(label, href, className) {
    var node = element('a', className, label);
    var safeUrl = safeHref(href);
    if (safeUrl) {
      node.href = safeUrl;
      node.target = '_blank';
      node.rel = 'noopener';
    } else {
      node.removeAttribute('href');
    }
    return node;
  }

  function apiHref(root, path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(String(path))) return safeHref(path);
    return safeHref(apiBase(root) + path);
  }

  function setStatus(node, message, isError) {
    node.textContent = message;
    node.classList.toggle('wc-cro-results__status--error', Boolean(isError));
  }

  function progressMessage(status) {
    return {
      pending: 'Preparing your CRO audit...',
      crawling: 'Crawling your public store pages...',
      measuring: 'Measuring Core Web Vitals...',
      analyzing: 'Generating your CRO report...'
    }[status] || 'Generating your CRO report...';
  }

  function statusStyle(status) {
    if (status === 'good') return 'good';
    if (status === 'warn' || status === 'needs-improvement') return 'warn';
    return 'high';
  }

  function badge(label, status) {
    return element('span', 'wc-cro-results__badge wc-cro-results__badge--' + statusStyle(status), text(label));
  }

  function formatMilliseconds(value) {
    return value == null ? 'Unavailable' : (Number(value) / 1000).toFixed(1) + 's';
  }

  function getCwvSummary(cwv) {
    if (!Array.isArray(cwv)) return {};
    function hasData(item) {
      if (!item || item.error) return false;
      var mobileData = item.mobile || item;
      if (mobileData.error) return false;
      return !!(mobileData.field || mobileData.originField || mobileData.lab);
    }
    var entry = cwv.find(function (item) { return item.type === 'homepage' && hasData(item); }) ||
      cwv.find(hasData);
    if (!entry) return {};

    var mobile = entry.mobile || entry;
    var core = mobile.field || mobile.originField || mobile.lab || {};
    var field = mobile.field || mobile.originField || {};
    var lab = mobile.lab || {};
    return {
      lcp: core.lcpMs,
      lcpRating: core.lcpRating,
      cls: core.cls,
      clsRating: core.clsRating,
      inp: field.inpMs,
      inpRating: field.inpRating,
      mobileScore: lab.performanceScore
    };
  }

  function metric(label, value, status) {
    var node = element('div', 'wc-cro-results__metric');
    if (status) node.classList.add('wc-cro-results__metric--' + statusStyle(status));
    return append(node, element('span', '', label), element('strong', '', value));
  }

  function renderScan(root, audit) {
    var signals = audit.signals || {};
    var scan = element('section');
    var scanHead = element('div', 'wc-cro-results__scan-head');
    var source = element('p', 'wc-cro-results__source');
    append(source, document.createTextNode('Public pages fetched from '), link(text(audit.storeUrl), audit.storeUrl));

    var sourceColumn = append(element('div'), element('p', 'wc-cro-results__label', 'Live CRO scan'), source);
    var scoreColumn = append(
      element('div', 'wc-cro-results__score'),
      element('p', 'wc-cro-results__label', 'CRO score'),
      element('strong', '', signals.croScore == null ? 'Unavailable' : signals.croScore + '%')
    );
    append(scanHead, sourceColumn, scoreColumn);
    scan.appendChild(scanHead);

    if (Array.isArray(signals.summary) && signals.summary.length) {
      var summary = element('div', 'wc-cro-results__summary');
      signals.summary.forEach(function (line) { summary.appendChild(element('div', '', line)); });
      scan.appendChild(summary);
    }

    var cwv = getCwvSummary(audit.cwv);
    var metrics = element('div', 'wc-cro-results__metrics');
    append(
      metrics,
      metric('LCP', formatMilliseconds(cwv.lcp), cwv.lcpRating),
      metric('CLS', cwv.cls == null ? 'Unavailable' : Number(cwv.cls).toFixed(2), cwv.clsRating),
      metric('INP', cwv.inp == null ? 'Unavailable' : cwv.inp + 'ms', cwv.inpRating),
      metric('MOBILE SCORE', cwv.mobileScore == null ? 'Unavailable' : String(cwv.mobileScore), cwv.mobileScore == null ? '' : cwv.mobileScore >= 90 ? 'good' : cwv.mobileScore >= 50 ? 'warn' : 'high')
    );
    scan.appendChild(metrics);

    if (Array.isArray(signals.signals) && signals.signals.length) {
      var grid = element('div', 'wc-cro-results__grid');
      signals.signals.forEach(function (signal) {
        var head = append(element('div', 'wc-cro-results__signal-head'), element('h3', '', text(signal.label)), badge(signal.status, signal.status));
        grid.appendChild(append(element('article', 'wc-cro-results__signal'), head, element('p', '', text(signal.detail))));
      });
      scan.appendChild(grid);
    }

    root.appendChild(scan);
  }

  function renderPages(root, pages) {
    if (!Array.isArray(pages) || !pages.length) return;
    var section = append(element('section', 'wc-cro-results__section'), element('h2', 'wc-cro-results__section-title', 'Pages crawled'));
    var grid = element('div', 'wc-cro-results__grid');
    pages.forEach(function (page) {
      var metrics = element('dl', 'wc-cro-results__page-metrics');
      if (page.accessible) {
        [
          ['Visible words', page.wordCount],
          ['CTA terms', page.ctaCount],
          ['Product links', page.productLinkCount]
        ].forEach(function (item) {
          var metric = element('div');
          append(metric, element('dt', '', item[0]), element('dd', '', text(item[1], '0')));
          metrics.appendChild(metric);
        });
      } else {
        var crawlStatus = element('div', 'wc-cro-results__page-metric--status');
        append(crawlStatus, element('dt', '', 'Crawl status'), element('dd', '', 'Not crawled'));
        metrics.appendChild(crawlStatus);
      }
      grid.appendChild(append(
        element('article', 'wc-cro-results__signal'),
        element('h3', '', PAGE_NAMES[page.type] || text(page.type)),
        element('p', '', text(page.title || page.note || page.url)),
        metrics
      ));
    });
    section.appendChild(grid);
    root.appendChild(section);
  }

  function labeledParagraph(label, value) {
    var paragraph = element('p');
    append(paragraph, element('strong', '', label + ':'), document.createTextNode(' ' + text(value)));
    return paragraph;
  }

  function renderTeaser(root, audit) {
    if (!Array.isArray(audit.teaser) || !audit.teaser.length) return;
    var section = append(element('section', 'wc-cro-results__section'), element('h2', 'wc-cro-results__section-title', 'Top 3 conversion issues found'));
    var source = element('p', 'wc-cro-results__source');
    append(source, document.createTextNode('Evidence-backed findings from '), link(text(audit.storeUrl), audit.storeUrl));
    section.appendChild(source);
    var panel = element('div', 'wc-cro-results__panel');
    audit.teaser.forEach(function (issue) {
      var item = append(
        element('article', 'wc-cro-results__issue'),
        element('h3', '', text(issue.title)),
        labeledParagraph('Location', issue.location),
        labeledParagraph('Impact', issue.impact)
      );
      if (issue.dataProof) {
        var evidence = element('div', 'wc-cro-results__evidence');
        append(evidence, element('strong', '', 'Evidence:'), document.createTextNode(' ' + issue.dataProof));
        item.appendChild(evidence);
      }
      panel.appendChild(item);
    });
    section.appendChild(panel);
    root.appendChild(section);
  }

  function renderFinding(parent, finding) {
    var detail = finding.recommendedFix || finding.fix || finding.whatWeFound || finding.reason || finding.dataProof;
    parent.appendChild(append(
      element('article', 'wc-cro-results__fix'),
      element('h3', '', text(finding.title)),
      element('p', '', text(detail)),
      badge((finding.priority || finding.impact || 'Medium') + ' impact', finding.priority || finding.impact || 'Medium')
    ));
  }

  function renderTabbedFinding(parent, finding) {
    var evidence = finding.whatWeFound || finding.dataProof;
    var reason = finding.whyItMatters || finding.reason;
    var fix = finding.recommendedFix || finding.fix;
    var priority = finding.priority || finding.impact || 'Medium';
    var item = append(
      element('article', 'wc-cro-results__tab-finding'),
      append(element('div', 'wc-cro-results__tab-finding-head'), element('h3', '', text(finding.title)), badge(priority + ' impact', priority))
    );
    var details = element('div', 'wc-cro-results__tab-finding-details');
    [
      ['Evidence', evidence],
      ['Why it matters', reason],
      ['Recommended fix', fix]
    ].forEach(function (detail) {
      if (!detail[1]) return;
      details.appendChild(append(element('div'), element('span', '', detail[0]), element('p', '', detail[1])));
    });
    if (details.children.length) item.appendChild(details);
    parent.appendChild(item);
  }

  function mergeFindings(findings) {
    var merged = new Map();
    findings.forEach(function (finding) {
      var key = text(finding.title).toLowerCase();
      var existing = merged.get(key);
      if (!existing) {
        merged.set(key, Object.assign({}, finding));
        return;
      }
      var combined = Object.assign({}, existing, finding);
      combined.whatWeFound = finding.whatWeFound || existing.whatWeFound || finding.dataProof || existing.dataProof;
      combined.dataProof = finding.dataProof || existing.dataProof || finding.whatWeFound || existing.whatWeFound;
      combined.whyItMatters = finding.whyItMatters || existing.whyItMatters || finding.reason || existing.reason;
      combined.reason = finding.reason || existing.reason || finding.whyItMatters || existing.whyItMatters;
      combined.recommendedFix = finding.recommendedFix || existing.recommendedFix || finding.fix || existing.fix;
      combined.fix = finding.fix || existing.fix || finding.recommendedFix || existing.recommendedFix;
      combined.priority = finding.priority || existing.priority || finding.impact || existing.impact;
      combined.impact = finding.impact || existing.impact || finding.priority || existing.priority;
      merged.set(key, combined);
    });
    return Array.from(merged.values());
  }

  function buildReportTabs(pages, sections) {
    var pageByKey = new Map((pages || []).map(function (page) { return [page.page, page]; }));
    var sectionById = new Map((sections || []).map(function (section) { return [section.id, section]; }));
    var configuredSectionIds = new Set();
    REPORT_TAB_CONFIG.forEach(function (tab) {
      tab.sections.forEach(function (id) { configuredSectionIds.add(id); });
    });

    var tabs = REPORT_TAB_CONFIG.map(function (config) {
      var tabPages = config.pages.map(function (key) { return pageByKey.get(key); }).filter(Boolean);
      var tabSections = config.sections.map(function (id) { return sectionById.get(id); }).filter(Boolean);
      if (config.id === 'storewide') {
        tabSections = tabSections.concat((sections || []).filter(function (section) { return !configuredSectionIds.has(section.id); }));
      }
      var pageFindings = collectFindings(tabPages);
      var sectionFindings = collectFindings(tabSections);
      var summaries = tabPages.map(function (page) {
        return tabPages.length > 1 ? PAGE_NAMES[page.page] + ': ' + text(page.summary, 'No summary is available.') : page.summary;
      }).filter(Boolean);
      return {
        id: config.id,
        label: config.label,
        summary: summaries.join(' ') || (config.id === 'storewide' ? 'Cross-page findings affecting the storefront experience.' : ''),
        score: tabPages.length === 1 ? tabPages[0].score : null,
        findings: mergeFindings(pageFindings.concat(sectionFindings))
      };
    });

    return tabs.filter(function (tab) { return tab.summary || tab.findings.length; });
  }

  function renderFindingsTabs(root, pages, sections) {
    var entries = buildReportTabs(pages, sections);
    if (!entries.length) return;
    var report = append(element('section', 'wc-cro-results__report'), element('h2', 'wc-cro-results__section-title', 'CRO findings'));
    var tabs = element('div', 'wc-cro-results__tabs');
    var body = element('div', 'wc-cro-results__pagewise-body');
    var active = 0;

    function show(index) {
      active = index;
      Array.prototype.forEach.call(tabs.querySelectorAll('button'), function (tab, tabIndex) {
        tab.classList.toggle('wc-cro-results__tab--active', tabIndex === active);
        tab.setAttribute('aria-selected', String(tabIndex === active));
      });
      clearNode(body);
      var entry = entries[active];
      var heading = append(element('div', 'wc-cro-results__pagewise-head'), element('p', '', text(entry.summary, 'No summary is available.')));
      if (entry.score != null) heading.appendChild(badge(entry.score + '/100', entry.score >= 80 ? 'good' : entry.score >= 60 ? 'warn' : 'high'));
      body.appendChild(heading);
      if (Array.isArray(entry.findings) && entry.findings.length) {
        entry.findings.forEach(function (finding) { renderTabbedFinding(body, finding); });
      } else {
        body.appendChild(element('p', 'wc-cro-results__empty', 'No findings in this area.'));
      }
    }

    entries.forEach(function (entry, index) {
      var tab = element('button', 'wc-cro-results__tab', entry.label);
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', 'false');
      tab.addEventListener('click', function () { show(index); });
      tabs.appendChild(tab);
    });
    append(report, tabs, body);
    root.appendChild(report);
    show(active);
  }

  function highPriorityFixes(report) {
    var fixes = [];
    (report.pageWise || []).forEach(function (page) {
      (page.findings || []).forEach(function (finding) {
        if (finding.impact === 'High') fixes.push(finding);
      });
    });
    if (fixes.length < 5) {
      (report.sections || []).forEach(function (section) {
        (section.findings || []).forEach(function (finding) {
          if (finding.priority === 'High' && !fixes.some(function (existing) { return existing.title === finding.title; })) fixes.push(finding);
        });
      });
    }
    return fixes.slice(0, 7);
  }

  function renderDownloadButton(root, pdfUrl, apiRoot) {
    var href = apiHref(apiRoot, pdfUrl);
    if (!href) return;

    var actions = element('div', 'wc-cro-results__actions');
    var download = element('a', 'wc-cro-results__button', 'Download PDF');
    download.href = href;
    download.target = '_blank';
    download.rel = 'noopener';
    download.setAttribute('download', '');
    actions.appendChild(download);
    root.appendChild(actions);
  }

  function renderFullReport(root, report, pdfUrl, apiRoot) {
    if (!report) return;
    var overview = append(element('section', 'wc-cro-results__report'), element('h2', 'wc-cro-results__section-title', 'Full CRO Audit Report'));
    if (report.storeSummary) overview.appendChild(element('p', '', report.storeSummary));
    if (report.executiveSummary) {
      append(overview, element('h3', '', 'Executive Summary'), element('p', '', report.executiveSummary));
    }
    if (Array.isArray(report.quickWins) && report.quickWins.length) {
      overview.appendChild(element('h3', '', 'Quick wins (high impact, low effort)'));
      var quickWins = element('ol');
      report.quickWins.forEach(function (win) {
        var item = element('li');
        append(item, element('strong', '', text(win.title)), document.createTextNode(' - ' + text(win.detail)));
        quickWins.appendChild(item);
      });
      overview.appendChild(quickWins);
    }
    root.appendChild(overview);
    renderDownloadButton(root, pdfUrl, apiRoot);

    renderFindingsTabs(root, report.pageWise, report.sections);

    var fixes = highPriorityFixes(report);
    if (fixes.length) {
      var priority = append(element('section', 'wc-cro-results__section wc-cro-results__priority'), element('h2', 'wc-cro-results__section-title', 'Highest priority fixes'));
      fixes.forEach(function (finding) { renderFinding(priority, finding); });
      root.appendChild(priority);
    }

    if (Array.isArray(report.roadmap) && report.roadmap.length) {
      var roadmap = append(element('section', 'wc-cro-results__report'), element('h2', 'wc-cro-results__section-title', 'Priority roadmap'));
      var list = element('ol');
      report.roadmap.forEach(function (item) {
        var row = element('li');
        append(row, element('strong', '', text(item.item)), element('p', '', text(item.rationale)));
        list.appendChild(row);
      });
      roadmap.appendChild(list);
      root.appendChild(roadmap);
    }
  }

  function renderUnlockGate(root, audit, onUnlock, apiRoot) {
    if (audit.unlocked || audit.fullReport) {
      renderFullReport(root, audit.fullReport, audit.pdfUrl, apiRoot);
      return;
    }

    var section = append(
      element('section', 'wc-cro-results__report wc-cro-results__unlock'),
      element('h2', 'wc-cro-results__section-title', 'Unlock the full CRO audit report'),
      element('p', '', 'Get every finding, recommendation, and priority roadmap for this store.')
    );
    var form = element('form', 'wc-cro-results__unlock-form');
    var email = document.createElement('input');
    email.type = 'email';
    email.name = 'email';
    email.autocomplete = 'email';
    email.placeholder = 'you@company.com';
    email.required = true;
    email.setAttribute('aria-label', 'Email address');
    var phone = document.createElement('input');
    phone.type = 'tel';
    phone.name = 'phone';
    phone.autocomplete = 'tel';
    phone.placeholder = '+1 555 000 0000';
    phone.required = true;
    phone.setAttribute('aria-label', 'Phone number');
    var submit = element('button', 'wc-cro-results__button', 'Unlock full report');
    submit.type = 'submit';
    var message = element('p', 'wc-cro-results__unlock-message');
    append(form, email, phone, submit, message);
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      submit.disabled = true;
      submit.textContent = 'Unlocking report...';
      message.textContent = '';
      try {
        var full = await request(apiRoot, '/api/audits/' + encodeURIComponent(audit.auditId) + '/unlock', {
          method: 'POST',
          body: JSON.stringify({ email: email.value.trim(), phone: phone.value.trim() })
        });
        onUnlock(full);
      } catch (error) {
        message.textContent = error.message;
        submit.disabled = false;
        submit.textContent = 'Unlock full report';
      }
    });
    section.appendChild(form);
    root.appendChild(section);
  }

  function renderResults(root, content, cta, audit) {
    clearNode(content);
    var inner = element('div', 'wc-cro-results__inner');
    var hero = append(
      element('div', 'wc-cro-results__hero'),
      element('p', 'wc-cro-results__eyebrow', text(root.dataset.eyebrow, 'CRO Experts')),
      element('h1', '', text(root.dataset.heading, 'Boost Conversions with CRO Experts'))
    );
    var back = element('a', 'wc-cro-results__back');
    back.href = root.dataset.auditAgainUrl || '/pages/cro-audit';
    append(back, element('span', '', 'Back'), document.createTextNode(' ' + text(root.dataset.auditAgainLabel, 'Audit another store')));
    append(inner, hero, back);
    renderScan(inner, audit);
    renderPages(inner, audit.signals && audit.signals.pages);
    renderTeaser(inner, audit);
    renderUnlockGate(inner, audit, function (response) {
      audit.unlocked = true;
      audit.fullReport = response.fullReport;
      audit.pdfUrl = response.pdfUrl || audit.pdfUrl;
      renderResults(root, content, cta, audit);
    }, root);
    content.appendChild(inner);
    content.hidden = false;
    if (cta) cta.hidden = false;
    root.hidden = false;
  }

  function showFormMessage(form, message, isError) {
    var root = form.closest('[data-wc-cro-audit]');
    var node = root ? root.querySelector('[data-wc-cro-form-message]') : null;
    if (!node) {
      node = element('p', 'wc-cro__form-message');
      node.setAttribute('data-wc-cro-form-message', '');
      form.insertAdjacentElement('afterend', node);
    }
    node.textContent = message;
    node.hidden = false;
    node.classList.toggle('wc-cro__form-message--error', Boolean(isError));
    return node;
  }

  function initializeAuditForm(root) {
    root = root || document;
    var form = root.querySelector('[data-wc-cro-audit-form]');
    if (!form || form.dataset.wcCroBound === 'true') return;
    form.dataset.wcCroBound = 'true';

    var message = root.querySelector('[data-wc-cro-form-message]');
    var loading = root.querySelector('[data-wc-cro-loading]');
    var loadingMessage = root.querySelector('[data-wc-cro-loading-message]');
    var input = root.querySelector('[data-wc-cro-input]');
    var results = root.querySelector('[data-wc-cro-results]');
    var content = root.querySelector('[data-wc-cro-results-content]');
    var cta = root.querySelector('[data-wc-cro-results-cta]');
    if (!message) message = showFormMessage(form, '', false);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (form.reportValidity && !form.reportValidity()) return;
      var submit = form.querySelector('button[type="submit"]');
      var storeUrl = form.elements.store_url ? form.elements.store_url.value.trim() : '';
      var platform = form.elements.platform ? form.elements.platform.value || undefined : undefined;
      if (!results || !content) {
        showFormMessage(form, 'CRO results container is missing from this Shopify section. Please update the section markup with the latest wc-cro-audit.liquid.', true);
        return;
      }
      if (submit) submit.disabled = true;
      message.hidden = true;
      message.classList.remove('wc-cro__form-message--error');
      form.hidden = true;
      if (loading) loading.hidden = false;
      if (loadingMessage) loadingMessage.textContent = 'Starting your CRO audit...';

      try {
        var started = await request(root, '/api/audits', {
          method: 'POST',
          body: JSON.stringify({ url: storeUrl, platform: platform })
        });

        var audit;
        do {
          await new Promise(function (resolve) { window.setTimeout(resolve, POLL_INTERVAL_MS); });
          audit = await request(root, '/api/audits/' + encodeURIComponent(started.auditId));
          if (loadingMessage) loadingMessage.textContent = progressMessage(audit.status);
          if (audit.status === 'failed') throw new Error(audit.error || 'The audit could not be completed.');
        } while (audit.status !== 'teaser_ready');

        if (loading) loading.hidden = true;
        if (input) input.hidden = true;
        results.hidden = false;
        renderResults(results, content, cta, audit);
      } catch (error) {
        if (loading) loading.hidden = true;
        form.hidden = false;
        message.textContent = error.message || 'Unable to generate the CRO audit right now.';
        message.classList.add('wc-cro__form-message--error');
        message.hidden = false;
        if (submit) submit.disabled = false;
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-wc-cro-audit]').forEach(initializeAuditForm);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-wc-cro-audit-form]');
    if (!form || form.dataset.wcCroBound === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    initializeAuditForm(form.closest('[data-wc-cro-audit]') || document);
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAuditForm(event.target);
  });
}());
